import * as ambassadorWixSsrV1InvalidateCacheRequest from './ssr-v1-invalidate-cache-request-cache.http.js';
import * as ambassadorWixSsrV1InvalidateCacheRequestTypes from './ssr-v1-invalidate-cache-request-cache.types.js';
import * as ambassadorWixSsrV1InvalidateCacheRequestUniversalTypes from './ssr-v1-invalidate-cache-request-cache.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function invalidateCache(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixSsrV1InvalidateCacheRequestUniversalTypes.InvalidateCacheRequest,
  ambassadorWixSsrV1InvalidateCacheRequestTypes.InvalidateCacheRequest,
  ambassadorWixSsrV1InvalidateCacheRequestUniversalTypes.InvalidateCacheResponse,
  ambassadorWixSsrV1InvalidateCacheRequestTypes.InvalidateCacheResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixSsrV1InvalidateCacheRequest.invalidateCache(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/invalidate-cache',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function purgeSiteCache(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixSsrV1InvalidateCacheRequestUniversalTypes.PurgeSiteCacheRequest,
  ambassadorWixSsrV1InvalidateCacheRequestTypes.PurgeSiteCacheRequest,
  ambassadorWixSsrV1InvalidateCacheRequestUniversalTypes.PurgeSiteCacheResponse,
  ambassadorWixSsrV1InvalidateCacheRequestTypes.PurgeSiteCacheResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixSsrV1InvalidateCacheRequest.purgeSiteCache(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/purge-site-cache',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  InvalidateCacheRequest as InvalidateCacheRequestOriginal,
  InvalidationMethods as InvalidationMethodsOriginal,
  InvalidationMethodsInvalidateByOneOf as InvalidationMethodsInvalidateByOneOfOriginal,
  InvalidateCacheResponse as InvalidateCacheResponseOriginal,
  PurgeSiteCacheRequest as PurgeSiteCacheRequestOriginal,
  PurgeSiteCacheResponse as PurgeSiteCacheResponseOriginal,
} from './ssr-v1-invalidate-cache-request-cache.types.js';
